export const JapanId = 87;
export const JapaneseCitizenshipId = 1034;
